/**
 * Scaffold Column Mapping
 * Scaffold uses semantic field names directly (no col1, col2 mapping needed)
 * This file provides a reverse mapping for dimension values
 */

/**
 * Identity mapping: field name to itself
 * Used for mapping dimension values to their field names
 */
export const SCAFFOLD_REVERSE_MAPPING: { [fieldName: string]: string } = {
  // Base measurements
  'scaffoldPlatform': 'scaffoldPlatform',
  'loadingBay4x2m': 'loadingBay4x2m',
  'stairAccess3x3m': 'stairAccess3x3m',

  // Scaffold Platform
  'scaffoldLevelCompact': 'scaffoldLevelCompact',
  'scaffoldGeotextileLayer': 'scaffoldGeotextileLayer',
  'scaffoldCrush6F2': 'scaffoldCrush6F2',
  'scaffoldType1': 'scaffoldType1',

  // Loading Bays
  'loadingLevelCompact': 'loadingLevelCompact',
  'loadingGeotextileLayer': 'loadingGeotextileLayer',
  'loadingCrush6F2': 'loadingCrush6F2',
  'loadingType1': 'loadingType1',

  // Stair Access
  'stairLevelCompact': 'stairLevelCompact',
  'stairGeotextileLayer': 'stairGeotextileLayer',
  'stairCrush6F2': 'stairCrush6F2',
  'stairType1': 'stairType1',
};
